import classNames from "classnames";
import React, { PropsWithChildren } from "react";

interface FormProps
  extends React.FormHTMLAttributes<HTMLFormElement>,
    PropsWithChildren {
  /** Extra classes to attach for modifying the standard pattern styles*/
  extraClasses?: string;
  /** Optional text used to provide an accessible label for the form*/
  ariaLabel?: string;
}

export const Form: React.FC<FormProps> = ({
  extraClasses,
  ariaLabel,
  children,
  ...props
}) => {
  const formClasses = classNames("form", {
    [`${extraClasses}`]: extraClasses,
  });

  return (
    <form className={formClasses} aria-label={ariaLabel} {...props}>
      {children}
    </form>
  );
};
